import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ArquivoVisita } from '../domain/arquivo-visita.model';
export class ArquivoVisitaSerializer extends DomainSerializer<ArquivoVisita> {}
